import Layout from './lander-layout'
import { Heading, Box, Text, Link } from 'theme-ui'
import ExploreKnowledgeBase from './exploreKnowledgeBase'
import Press from './press'
import Logomark from '../framework/logomark'
import s from '../../strings/strings'

const Index = () => {
  return (
    <Layout>
      <>
        {/* Large logo section */}
        <Box sx={{ 
          textAlign: 'center', 
          my: [3, null, 4],
          mb: [3, null, 4]
        }}>
          <Logomark 
            style={{ 
              height: '120px', 
              marginBottom: '15px',
              display: 'block',
              margin: '0 auto 15px auto'
            }} 
          />
          <Heading as="h1" sx={{ 
            fontSize: [6, null, 7], 
            fontWeight: 'bold',
            color: '#333',
            letterSpacing: '0.02em'
          }}>
            Dansk Samtale
          </Heading>
        </Box>

        <Heading
          as="h3"
          sx={{
            fontSize: [3, null, 4],
            lineHeight: 'body',
            mb: [3, null, 4]
          }}>
          {s.home_description || 'Dansk Samtale skaber rum til offentlig dialog om emner af offentlig interesse. Den egner sig især til drøftelser i store grupper på hundrede deltagere eller flere  - op til mange tusinde.'}
        </Heading>

        <Box sx={{ mb: [4, null, 5] }}>
          <Heading as="h3" sx={{ fontSize: [4], lineHeight: 'body', mb: [2, null, 3] }}>
            Sådan fungerer det
          </Heading>
          <Text>
            Drøftelsen indledes af en ”samtale-ejer,” som sætter emne, ramme og tone og inviterer andre ind på det site, der er oprettet til samtalen.
          </Text>
          <br />
          <Text>
            Deltagerne kan bidrage med kommentarer, forslag og perspektiver og give udtryk for deres mening om andres input ved at erklære sig enige eller uenige. På samme side kan de også se, hvordan drøftelsen udvikler sig og påvirke retningen med nye indlæg.
          </Text>
          <br />
          <Text>
            Samtalerne skal dreje sig om emnet/sagen, ikke hvem der har skrevet indlæggene. Der er ingen navne på indlæg og heller ingen registrering af synspunkter mv. Man risikerer ikke at blive hængt op på en bemærkning, løsrevet fra sin sammenhæng.          
          </Text>
          <br />
          <Text>
            Samtale-ejeren sørger for at samtalen modereres, så deltagerne kan koncentrere sig om sagen og slipper for spam og støj.
          </Text>
          <br />
          <Text>
            Efter samtalen bringer moderatoren vigtige pointer videre, men det er deltagerne også velkomne til. Alle inputs fra deltagerne kan ses i en afslutningsrapport.
          </Text>
        </Box>
          <br />
        <Press />
      </>
    </Layout>
  )
}

export default Index
